export default "https://cdn-static.gokick.com/assets/afaaccc9c40207d12945800ee9a4df41e308a977/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";